import { EnumModel } from 'app/shared/objects/EnumModel';
import {GridConfiguration, GridRequest} from '../../shared/helpers/dx-grid-helper';
export class Event {

  }



export class PastEventRequestModel extends GridRequest {
  past = true;
  searchTime = new Date();
}
export class NextEventRequestModel extends GridRequest {
  past = false;
  searchTime = new Date();
}

export class NextEventGridConfiguration extends GridConfiguration {

  constructor() {
    super();
    this.columns = [
      {
        caption: 'UPCOMING EVENTS',
        cellTemplate: 'imgAndName'
      },
      {
        dataField: 'timeFrom',
        dataType: 'date',
        format: 'dd/MM/yyyy',
        caption: 'DATE FROM'
      },
      {
        dataField: 'timeTo',
        dataType: 'date',
        format: 'dd/MM/yyyy',
        caption: 'DATE TO'
      },
      {
        caption: 'TIME FROM',
        dataField: 'timeFromString'
      },
      

      {
        caption: 'TIME TO',
        dataField: 'timeToString'
      },
      {
        caption: 'NUMBER OF ATTENDEES',
        dataField: 'attendeesInfo'
      },
      {
        cellTemplate: 'eventStatus'
      },
      {
        cellTemplate: 'buttons'
      }
    ];

    this.customSearch = [
      {
        fieldName: 'name',
        value: ''
      }
    ];
    this.paging = {
      enabled: true,
      pageIndex: 0,
      pageSize: 5
    };
    this.pager.showPageSizeSelector = false;
    // this.pager = {
    //   showPageSizeSelector: false,
    //   showNavigationButtons: true,
    //   allowedPageSizes: [5],
    //   pageSize: 5,
    //   showInfo: ''
    // };

    this.selection = {
      mode: 'none',
      allowSelectAll: false
    };
    this.sorting = { mode: 'none' };
  }


  mapGridRequest(gridRequest: GridRequest, loadOptions: any) {
    super.mapGridRequest(gridRequest, loadOptions);
    gridRequest.options.customSearch = this.customSearch;
  }
}
export class PastEventGridConfiguration extends GridConfiguration {

  constructor() {
    super();
    this.columns = [
      {
        caption: 'PAST EVENTS',
        cellTemplate: 'imgAndName'
      },
      {
        dataField: 'timeFrom',
        dataType: 'date',
        format: 'dd/MM/yyyy',
        caption: 'DATE FROM'
      },
      {
        dataField: 'timeTo',
        dataType: 'date',
        format: 'dd/MM/yyyy',
        caption: 'DATE TO'
      },
      {
        caption: 'TIME FROM',
        dataField: 'timeFromString'
      },
      

      {
        caption: 'TIME TO',
        dataField: 'timeToString'
      },
      {
        caption: 'NUMBER OF ATTENDEES',
        dataField: 'attendeesInfo'
      },
      {
        cellTemplate: 'eventStatus'
      },
      {
        cellTemplate: 'buttons'
      }
    ];

    this.customSearch = [
      {
        fieldName: 'name',
        value: ''
      }
    ];
    this.paging = {
      enabled: true,
      pageIndex: 0,
      pageSize: 5
    };
    this.pager.showPageSizeSelector = false;
    // this.pager = {
    //   showPageSizeSelector: false,
    //   showNavigationButtons: true,
    //   allowedPageSizes: [5],
    //   pageSize: 5,
    //   showInfo: ''
    // };

    this.selection = {
      mode: 'single',
      allowSelectAll: false
    };
    this.sorting = { mode: 'none' };
  }


  mapGridRequest(gridRequest: GridRequest, loadOptions: any) {
    super.mapGridRequest(gridRequest, loadOptions);
    gridRequest.options.customSearch = this.customSearch;
  }
}

export class EventListItemResponseModel {
  public Id: number;
  public Name: string;
  public TimeFrom: Date;
  public TimeTo: Date;
  public TimeRange: string;
  public MaxNumberOfAttendees: number;
  public NumberOfAttendees: number;
  public AttendeesInfo: string;
  public IsAlive: boolean;
  public EventImageUrl: string;
}




// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/events/event-database/event-database.model.ts